const appSettings = {
    production: process.env.NODE_ENV === 'production',
    reduxLogger: false,
    functionsUrl: 'https://us-central1-molo-customers.cloudfunctions.net/api/',
    onlyPersonalCustomer: true,
    onlyOneApplicant: true,
    minimumDepositRatio: 0.2,
};

export default appSettings;



// WEBPACK FOOTER //
// ./src/config/appSettings.js